import { Button, Typography } from "@material-ui/core";

const InformationBlock = ({ showHideModal }) => {
  return (
    <div className='border-container'>
      <div className='information-block'>
        <div className='text-container'>
          <Typography variant="h4">Castañeda Tacos and Restaurant is now open!</Typography>
          <div style={{ paddingLeft: '20px', paddingTop: '10px' }}>
            <Typography variant="body1">At Castañeda Tacos and Restaurant, we provide authentic homemade Mexican and American cuisine to our community and the
              surrounding area.</Typography>
            <Typography variant="body1">Don't forget to book your next conference with us. <Button size="small" variant="text" onClick={showHideModal} className='learnMore'>Learn more</Button>.</Typography>
            <Typography variant="body1">Come see us today at 231 Chicago Ave. Goshen, IN 46526.</Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InformationBlock;
